import { Alert, Button, Container, Stack, Typography } from '@mui/material';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import { Link, useRevalidator } from 'react-router-dom';

export default function ReturnTrialError() {
  const { t } = useIntlTranslations('returnTrialError');
  const { revalidate, state } = useRevalidator();
  return (
    <Container maxWidth="sm" sx={{ py: 4 }}>
      <Stack spacing={2}>
        <Alert severity="warning">{t('paymentFailed')}</Alert>
        <Typography>{t('description')}</Typography>
        <Button variant="contained" disabled={state === 'loading'} onClick={() => revalidate()}>
          {t('retry')}
        </Button>
        <Button component={Link} to="/hairdresser/subscription" replace>
          {t('subscription')}
        </Button>
      </Stack>
    </Container>
  );
}
